import { CardListOneConfigBase } from '@/views/game/components/gameCardSuit2/cardList/listOne'
/** 默认列表布局 */
export class _ListLayoutSubGame extends CardListOneConfigBase {
  protected initPC(isSidePlatform: boolean): this {
    if (isSidePlatform) {
      this.width = 1140
      this.rowCardCount = 6
      this.leftRightSpacing = 30
      this.topBotSpacing = 24
    } else {
      this.width = 970
      this.rowCardCount = 5
      this.leftRightSpacing = 30
      this.topBotSpacing = 24
    }
    return this
  }
  protected initH5(isSidePlatform: boolean): this {
    if (isSidePlatform) {
      this.width = 690
      this.rowCardCount = 3
      this.leftRightSpacing = 20
      this.topBotSpacing = 20
    } else {
      this.width = 520
      this.rowCardCount = 3
      this.leftRightSpacing = 20
      this.topBotSpacing = 20
    }
    return this
  }
}
